const sectionVariants = {
  default: { marginY: 4 },
};

export default sectionVariants;
